import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { BaseUrl, Url } from "../components/BaseUrl";
import { enqueueSnackbar } from "notistack";
import { Box, CircularProgress, Button } from "@mui/material";
import { FaPrint } from "react-icons/fa";

export const BonafideCertificate = () => {
  const [result, setResult] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState("");

  // --- Auth Logic ---
  const regenerateToken = () => {
    if (sessionStorage?.getItem("accesstoken")) {
      const response = jwtDecode(sessionStorage?.getItem("accesstoken"));
      const response1 = jwtDecode(sessionStorage?.getItem("refreshtoken"));
      if (
        response.exp < Math.floor(Date.now() / 1000) ||
        response1.exp < Math.floor(Date.now() / 1000)
      ) {
        navigate("/login");
      } else {
        if (
          sessionStorage.getItem("refreshtoken") &&
          sessionStorage.getItem("accesstoken")
        ) {
          let data = {
            refresh: sessionStorage?.getItem("refreshtoken"),
          };
          let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${Url}/token/refresh/`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage?.getItem("accesstoken")}`,
            },
            data: data,
          };
          axios
            .request(config)
            .then((response) => {
              sessionStorage.setItem("accesstoken", response.data.access);
            })
            .catch((error) => {
              if (error?.message === "Request failed with status code 500") {
                navigate("/login");
              }
              if (
                error?.response?.data?.errors?.detail ===
                "Given token not valid for any token type"
              ) {
                navigate("/login");
              }
            });
        } else {
          navigate("/login");
        }
      }
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    setCurrentDate(`${dd}/${mm}/${yyyy}`);

    const token = sessionStorage.getItem("accesstoken");
    const token1 = sessionStorage.getItem("refreshtoken");

    if (token && token1) {
      let currentDateToken = new Date();
      const decodedToken = jwtDecode(token);

      if (
        decodedToken.exp * 1000 - currentDateToken.getTime() <
        59 * 60 * 1000
      ) {
        regenerateToken();
      }

      const response = jwtDecode(token);

      axios
        .get(
          `${BaseUrl}/${response.college}/bonafide/?search=${
            jwtDecode(sessionStorage.getItem("accesstoken")).registration_number
          }`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accesstoken")}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response?.data?.[0]?.status === "pending") {
            enqueueSnackbar("Bonafide Certificate is not verified yet.", {
              variant: "warning",
              autoHideDuration: 3000,
            });
            navigate("/dashboard");
          }
          setResult(response.data);
        })
        .catch((error) => {
          if (
            error?.response?.data?.errors?.detail ===
            "Given token not valid for any token type"
          ) {
            navigate("/login");
          }
        });
    } else {
      navigate("/login");
    }
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const data = result?.[0];
  const college = data?.college_details;
  const student = data?.student_details?.personal_information;
  const academic = data?.student_details?.academic_information;

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Tinos:wght@400;700&display=swap');

          body {
            background-color: #f3f4f6;
          }
          
          .certificate-container {
            width: 210mm;
            min-height: 297mm;
            /* UPDATED: Reduced margins to 10mm all around to maximize width */
            padding: 10mm; 
            margin: 20px auto;
            background: white;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
            font-family: 'Tinos', serif;
            color: #000;
            position: relative;
          }

          @media print {
            @page {
              size: A4;
              margin: 0; 
            }
            body {
              background-color: white;
            }
            .certificate-container {
              margin: 0;
              box-shadow: none;
              width: 100%;
              height: 100%;
              padding: 10mm; 
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Control Bar */}
      <Box
        className="no-print"
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          marginTop: 4,
          marginBottom: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<FaPrint />}
          onClick={handlePrint}
        >
          Print / Download PDF
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      {/* A4 Page */}
      <div className="certificate-container flex flex-col">
        
        {/* Header Section */}
        {/* We use flex-nowrap to prevent wrapping. 
            The Logo and Spacer are fixed width (w-24), 
            and the center div grows (flex-1) to take all remaining space. */}
        <div className="flex flex-row items-center justify-between border-b-2 border-black pb-2 mb-4 w-full">
            
            {/* Logo: Fixed Width to prevent squishing */}
            <div className="w-24 flex-shrink-0 flex justify-start">
             {college?.college_logo && (
                <img
                  src={`https://smartone.pythonanywhere.com${college.college_logo}`}
                  alt="Logo"
                  className="h-24 w-24 object-contain"
                />
             )}
            </div>

            {/* Center Text: Takes ALL available space */}
            <div className="flex-1 text-center px-2">
                <h1 className="text-xs font-bold tracking-widest uppercase mb-0 text-gray-600">
                    Department of Science & Technology
                </h1>
                
                {/* College Name: Ensure no wrap if possible, using flexible text size */}
                <h2 className="text-xl font-bold uppercase text-blue-900 my-1 whitespace-nowrap overflow-hidden text-ellipsis">
                    {college?.college_name}
                </h2>
                
                <p className="text-xs font-semibold mb-0">
                    {college?.college_address}
                </p>
                <p className="text-[10px] text-gray-700 mt-1">
                    Email: {college?.college_email} | Phone: {college?.phone_number}
                </p>
            </div>

            {/* Right Spacer: Same width as Logo to keep text perfectly centered */}
            <div className="w-24 flex-shrink-0"></div>
        </div>

        {/* Ref No & Date */}
        <div className="flex justify-between text-sm font-semibold mb-8 px-4">
            <p>Ref No: <span className="font-normal border-b border-dotted border-black px-2">{data?.id ? `BON/${new Date().getFullYear()}/${data.id}` : "_________"}</span></p>
            <p>Date: <span className="font-normal">{currentDate}</span></p>
        </div>

        {/* Title */}
        <div className="text-center mb-10">
            <h1 className="text-2xl font-bold uppercase underline decoration-2 underline-offset-4">
                Bonafide Certificate
            </h1>
        </div>

        {/* Body Content */}
        <div className="text-lg leading-relaxed text-justify px-4 mb-16 font-light">
            <p className="indent-12 mb-6">
                This is to certify that Mr./Ms. <span className="font-bold uppercase px-1">{student?.first_name} {student?.last_name}</span>, 
                Son/Daughter of <span className="font-bold uppercase px-1">{student?.father_name}</span>, 
                bearing Registration Number <span className="font-bold px-1">{student?.registration_number}</span> 
                is a bonafide student of this Institution.
            </p>
            <p className="indent-12 mb-6">
                He/She is currently studying in the <span className="font-bold">{academic?.year}</span> Year 
                (Session <span className="font-bold">{academic?.session || "20__-20__"}</span>) 
                of the <span className="font-bold uppercase">{academic?.branch}</span> Branch under the B.Tech Programme.
            </p>
            <p className="indent-12">
                His/Her date of admission to this institute is <span className="font-bold">{academic?.date_of_admission || "N/A"}</span>. 
                To the best of my knowledge, he/she bears a good moral character.
            </p>
        </div>

        {/* Footer / Signature (Pushed to bottom using mt-auto) */}
        <div className="flex justify-between items-end mt-auto px-6 pb-4">
            <div className="text-center w-1/3">
               {/* Space for Clerk/Assistant Signature if needed */}
            </div>

            <div className="text-center w-64">
                <div className="h-12 mb-2">
                    {/* Signature Image Placeholder */}
                </div>
                <p className="font-bold text-base border-t border-gray-400 pt-1">Principal / O.S.D</p>
                <p className="text-xs font-semibold">{college?.college_name}</p>
            </div>
        </div>

        {/* Bottom Note */}
        <div className="w-full text-center text-[10px] text-gray-400 mt-2">
            <p>This is a computer-generated document verified by college authority. No signature is required.</p>
        </div>

      </div>
    </>
  );
};

export default BonafideCertificate;
